import { cva, type VariantProps } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';
import * as React from 'react';

import { cn } from '@apps/web/lib/utils';

const spinnerVariants = cva('animate-spin', {
    variants: {
        size: {
            xs: 'size-3',
            sm: 'size-3.5',
            md: 'size-4',
            lg: 'size-5',
            xl: 'size-6',
        },
        tone: {
            current: 'text-current',
            muted: 'text-muted-foreground',
            primary: 'text-primary',
            destructive: 'text-destructive',
            success: 'text-emerald-600 dark:text-emerald-400',
        },
    },
    defaultVariants: {
        size: 'md',
        tone: 'current',
    },
});

type SpinnerProps = Omit<React.ComponentProps<typeof LoaderCircle>, 'size'> &
    VariantProps<typeof spinnerVariants>;

function Spinner({ className, size, tone, ...props }: SpinnerProps) {
    return (
        <LoaderCircle
            // Decorative by default; a labeled spinner is the status itself.
            aria-hidden={props['aria-label'] === undefined}
            data-slot="spinner"
            className={cn(spinnerVariants({ size, tone }), className)}
            {...props}
        />
    );
}

export { Spinner, spinnerVariants };
